<div class="page-description-section">
    <div appLocalizationPopupDirective localizationCode="AdpMappingsPageDescription">
        {{ 'AdpMappingsPageDescription' | translate: {Default: "Map incoming Adp worker fields to HubbubHR fields. Employees, EmploymentRecords, Compensation and the employee's Position are updated (or created) from these mappings each time the import runs."} }}
    </div>
</div>

<app-data-grid-comp
    [columns]="columns"
    [gridDataResult]="gridDataResult"
    [pageSize]="pageSize"
    [skip]="skip"
    category="Mappings"
    [rowSelectionSettings]="{
        canSelectRows: true,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    [sortable]="{
        mode: 'multiple'
    }"
    [sortableColumns]="sortableColumns"
    [sort]="sort"
    clickableRows="true"
    [searchable]="false"
    [filter]="null"
    [filterable]="null"
    [filterCategories]="null"
    [isLoading]="isLoading"
    [clearSelectedItems]="clearSelectedItems"
    (emitSortEvent)="sortChange($event)"
    (emitPageChangeEvent)="pageChange($event)"
    (emitOpenDialogEvent)="navigateToMapping($event)"
    (emitDeleteEvent)="deleteAllSelected($event)"
></app-data-grid-comp>
